import Node from './Node';
import BinaryNode from './BinaryNode';
import TextType from './TextType';

export default class ExponentiationNode extends BinaryNode {

	protected create (left: Node, right: Node) {
		return new ExponentiationNode(left, right);
	}

	protected getTextInfix (textType = TextType.PLAIN) {
		return textType !== TextType.PLAIN ? '^{' : ' ^ ';
	}

	protected getTextPostfix (textType = TextType.PLAIN) {
		return textType !== TextType.PLAIN ? '})' : ')';
	}
}


// WEBPACK FOOTER //
// ./code/project/modules/parsing/nodes/ExponentiationNode.ts